// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CapsuleButton, CircleButton } = require('client-v2/common/components/buttons')
const Modal = require('client-v2/common/components/modal')
const socialProviders = require('client-v2/common/containers/auth-modal-v2/providers')
const Icon = require('client-v2/common/containers/icons/component')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('AuthModalV2')

class AuthModalV2 extends React.PureComponent {
  constructor(props) {
    super(props)

    this.contentRef = React.createRef()

    this.state = { showMoreSelected: false }

    // Ensure function references do not change between render calls
    this.onShowMore = this.onShowMore.bind(this)
    this.onSocialProviderClick = this.onSocialProviderClick.bind(this)
  }

  // Event handler methods

  onShowMore() {
    this.setState(() => ({ showMoreSelected: true }))
  }

  onSocialProviderClick(event) {
    const { provider } = event.currentTarget.dataset
    this.props.onSocialProviderAuth(provider)
  }

  // Render methods

  renderErrorMessage() {
    const { errorType, errorProvider } = this.props
    if (!errorType) {
      return null
    }
    const providerName = socialProviders.getName(errorProvider)
    let message = 'Please try again.'
    if (errorType === 'permission') {
      message = 'Please make sure you are logged-in to your social account, then try again.'
    }
    return tag('div', {
      className: bem.element('error')
    },
      tag('div', {
        className: bem.element('heading')
      },
        `There was a problem connecting with your ${providerName} account.`
      ),
      tag('div', {
        className: bem.element('error-message')
      },
        message,
        '\n',
        'If you continue to have this problem, ',
        tag('a', {
          className: bem.element('error-href'),
          href: 'mailto:support@mix.com'
        },
          'contact support'
        ),
        '.'
      )
    )
  }

  renderContent() {
    const { errorType } = this.props
    const providerLimit = this.state.showMoreSelected ? socialProviders.length : 3
    return tag([
      !errorType && tag('div', {
        className: bem.element('heading')
      },
        'Sign in'
      ),
      socialProviders.slice(0, providerLimit).map(provider => {
        return tag(CapsuleButton, {
          key: provider.id,
          className: bem.element('auth-button'),
          'data-provider': provider.id,
          tabIndex: '0',
          onClick: this.onSocialProviderClick
        },
          tag(Icon, {
            id: provider.iconId || provider.id,
            className: bem.element('auth-icon')
          }),
          `Sign in with ${provider.name}`
        )
      }),
      !this.state.showMoreSelected && tag(CapsuleButton, {
        className: bem.element('auth-button', 'show-more'),
        onClick: this.onShowMore
      },
        'More services'
      )
    ])
  }

  renderTermsOfService() {
    return (
      tag('div', {
        className: bem.element('bottom-text')
      },
        tag('a', {
          className: bem.element('bottom-href'),
          href: '/tos'
        },
          `Terms of Service`
        ),
        ` · `,
        tag('a', {
          className: bem.element('bottom-href'),
          href: '/privacy'
        },
          `Privacy Policy`
        )
      )
    )
  }

  render() {
    return (
      tag(Modal, {
        className: classNames(
          this.props.className,
          bem.block()
        ),
        onDismiss: this.props.onClose
      },
        tag(CircleButton, {
          className: bem.element('close-button'),
          onClick: this.props.onClose
        },
          tag(Icon, { id: 'x' })
        ),
        this.renderErrorMessage(),
        this.renderContent(),
        this.renderTermsOfService()
      )
    )
  }
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  AuthModalV2.propTypes = {
    // Values
    className: PropTypes.string,
    errorType: PropTypes.string,
    errorProvider: PropTypes.string,
    // Callbacks
    onClose: PropTypes.func.isRequired,
    onSocialProviderAuth: PropTypes.func.isRequired
  }
}

module.exports = AuthModalV2
